"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Footer = void 0;
const react_1 = require("react");
const Context_1 = require("./Context");
;
const Footer = ({ children }) => {
    const containerContext = (0, react_1.useContext)(Context_1.ContainerContext);
    (0, react_1.useEffect)(() => {
        if (!children)
            return;
        containerContext.setFooter(children);
    }, [children]);
    return null;
};
exports.Footer = Footer;
